import axios from "axios";
import { getToken } from "./AuthService";
import { beginUpdateRequest } from './frontendUpdates';

export const BASE_URL = process.env.REACT_APP_BACKEND_HOST;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use((config) => {
  config.finishFrontendUpdateRequest = beginUpdateRequest();
  return config;
});
const finishRequest = (config) => {
  if (config && config.finishFrontendUpdateRequest) config.finishFrontendUpdateRequest();
};
axiosInstance.interceptors.response.use((response) => {
  finishRequest(response.config);
  return response;
}, (error) => {
  finishRequest(error.config);
  return Promise.reject(error);
});

export const setHeaders = (token) => {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + token;
};

export const get = (url, params) => {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + getToken();
  return axiosInstance.get(url, params);
};

export const post = (url, params) => {
  return axiosInstance.post(url, params);
};

export const del = (url) => {
  return axiosInstance.delete(url);
};

export const put = (url, params) => {
  return axiosInstance.put(url, params);
};

export const patch = (url, params) => {
  return axiosInstance.patch(url, params);
};
